import styled from 'styled-components';
import { media } from 'designsystem';

const DesktopImagesWrapper = styled.div`
  width: 100%;
  min-height: 400px;
  
  ${media.tablet`
    min-height: 500px;
  `}
  
  ${media.desktop` 
    position: relative;
  `}
`;

export default DesktopImagesWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/LinkBanner/DesktopImagesWrapper.jsx